import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'checkout-card-offer-header-byou',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './card-offer-header-byou.component.html',
    styleUrl: 'card-offer-header-byou.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardOfferHeaderByouComponent {
    @Input() public dataEnvelope: string;
    @Input() public catchyDescription: string;
    @Input() public gencode: string;
    @Input() public isLocked: boolean;
    @Input() public canBeLockedPlan: boolean;
    @Input() public connectionSpeed: '4g' | '5g';
    @Input() public atLeastOneBlockablePlan: boolean = false;
    @Input() public hasHat: boolean = false;

    @Output() public lockedToggleEvent = new EventEmitter<boolean>();

    public lockedToggle(): void {
        this.isLocked = !this.isLocked;
        this.lockedToggleEvent.emit(this.isLocked);
    }
}
